import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// import moment from 'moment';

import { user } from 'services';
import { deletePlate } from 'services/payments-service';
import { TableExt, TableInfo, Confirm, themes, GridBox, GridUpdateMessage } from 'libs/ui';
import UserForm from './forms/user-form';
import { getTableParams } from './grid.params';

export const UserGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, clientId, updateEntry } = props;
  //const interface1 = props.interface;
  const [showForm, setShowForm] = useState('');
  const [message, setMessage] = useState('');
  const [row, setRow] = useState({});
  const [confirm, setConfirm] = useState(null);

  const { t } = useTranslation();

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(null);
  };

  /**
   * delete item
   */
  // const delItem = (id) => {
  //   deletePlate(id).then(() => {
  //     props.getEntries({ offset: 0 }, null, true);
  //     closeConfirm();
  //   });
  // };

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  // const delItemAction = (row) => {
  //   setRow(row);
  //   setConfirm({
  //     title: t('messages.СО ') + row.mean_id + t('grid. будет удалено. Продолжить?'),
  //     width: '440px',
  //     type: 'danger',
  //     cancelButton: { text: t('buttons.Отмена'), func: closeConfirm },
  //     acceptButton: { text: t('buttons.Удалить'), func: () => delItem(row.id), theme: themes.red },
  //   });
  // };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const rightEdit = user.haveRight('users.update');
  // const rightDel = user.haveRight('users.delete');
  const rightAdd = user.haveRight('users.add');
  const actions = [];
  // if (rightEdit) {
  //   actions.push({ title: 'Редактировать', action: editItemAction });
  // }
  // if (rightDel) {
  //   actions.push({ title: t('buttons.Удалить'), action: delItemAction });
  // }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить пользователя'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }
  if (count) {
    getXlsAction(topActions);
  }

  const initial = showForm === 'addForm' ? {} : { ...row };
  const tableParams = useMemo(() => getTableParams(t), []);
  // console.log('🚀 ~ UserGrid ~ tableParams:', tableParams, actions);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Пользователи')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={clientId}
        onRowClick={rightEdit ? editItemAction : undefined}
        {...tableParams}
        updateEntry={updateEntry}
      />

      {confirm && <Confirm {...confirm} />}

      {showForm && (
        <UserForm type={showForm} close={() => setShowForm('')} id={row.id} setMessage={setMessage} refresh={props.refresh} initialValues={initial} />
      )}

      {message && <GridUpdateMessage>{message}</GridUpdateMessage>}
    </GridBox>
  );
};
